<h1 mat-dialog-title>Are you sure?</h1>
@if (messageContainsHtml) {
    <div mat-dialog-content [innerHtml]="message"></div>
} @else {
    <div mat-dialog-content>
        @if (message) {
            <p>{{ message }}</p>
        }
    </div>
}

<div mat-dialog-actions class="config-change-actions">
    @switch (confirmButton.type) {
        @default {
            <button
                mat-stroked-button
                [style.color]="confirmButton.color"
                [style.background-color]="confirmButton.backgroundColor"
                (click)="onClose(true)"
                type="button">
                {{ confirmButton.text }}
            </button>
        }
        @case ('raised') {
            <button
                mat-raised-button
                [style.color]="confirmButton.color"
                [style.background-color]="confirmButton.backgroundColor"
                (click)="onClose(true)"
                type="button">
                {{ confirmButton.text }}
            </button>
        }
        @case ('stroked') {
            <button
                mat-stroked-button
                [style.color]="confirmButton.color"
                [style.background-color]="confirmButton.backgroundColor"
                (click)="onClose(true)"
                type="button">
                {{ confirmButton.text }}
            </button>
        }
        @case ('flat') {
            <button
                mat-flat-button
                [style.color]="confirmButton.color"
                [style.background-color]="confirmButton.backgroundColor"
                (click)="onClose(true)"
                type="button">
                {{ confirmButton.text }}
            </button>
        }
        @case ('icon') {
            <button
                mat-icon-button
                [style.color]="confirmButton.color"
                [style.background-color]="confirmButton.backgroundColor"
                (click)="onClose(true)"
                type="button">
                {{ confirmButton.text }}
            </button>
        }
        @case ('fab') {
            <button
                mat-fab-button
                [style.color]="confirmButton.color"
                [style.background-color]="confirmButton.backgroundColor"
                (click)="onClose(true)"
                type="button">
                {{ confirmButton.text }}
            </button>
        }
        @case ('mini-fab') {
            <button
                mat-raised-button
                [style.color]="confirmButton.color"
                [style.background-color]="confirmButton.backgroundColor"
                (click)="onClose(true)"
                type="button">
                {{ confirmButton.text }}
            </button>
        }
    }

    @switch (cancelButton.type) {
        @default {
            <button
                mat-stroked-button
                [style.color]="cancelButton.color"
                [style.background-color]="cancelButton.backgroundColor"
                (click)="onClose(false)"
                type="button">
                {{ cancelButton.text }}
            </button>
        }
        @case ('raised') {
            <button
                mat-raised-button
                [style.color]="cancelButton.color"
                [style.background-color]="cancelButton.backgroundColor"
                (click)="onClose(false)"
                type="button">
                {{ cancelButton.text }}
            </button>
        }
        @case ('stroked') {
            <button
                mat-stroked-button
                [style.color]="cancelButton.color"
                [style.background-color]="cancelButton.backgroundColor"
                (click)="onClose(false)"
                type="button">
                {{ cancelButton.text }}
            </button>
        }
        @case ('flat') {
            <button
                mat-flat-button
                [style.color]="cancelButton.color"
                [style.background-color]="cancelButton.backgroundColor"
                (click)="onClose(false)"
                type="button">
                {{ cancelButton.text }}
            </button>
        }
        @case ('icon') {
            <button
                mat-icon-button
                [style.color]="cancelButton.color"
                [style.background-color]="cancelButton.backgroundColor"
                (click)="onClose(false)"
                type="button">
                {{ cancelButton.text }}
            </button>
        }
        @case ('fab') {
            <button
                mat-fab-button
                [style.color]="cancelButton.color"
                [style.background-color]="cancelButton.backgroundColor"
                (click)="onClose(false)"
                type="button">
                {{ cancelButton.text }}
            </button>
        }
        @case ('mini-fab') {
            <button
                mat-raised-button
                [style.color]="cancelButton.color"
                [style.background-color]="cancelButton.backgroundColor"
                (click)="onClose(false)"
                type="button">
                {{ cancelButton.text }}
            </button>
        }
    }
</div>
